import {
  useGetRecalculatePlanQuery,
  useGetTrainingNutritionQuery,
  useTrainingNutritionExportMutation,
} from "@/app/kpi/kpi.api";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import DescriptionHeadings from "@/shared/components/atoms/DescriptionHeadings";
import KpiTableComponent from "@/shared/components/organisms/KpiTableComponent";
import KpiTableNRCComponent from "@/shared/components/organisms/KpiTableNRCComponent";
import { MultiSelectAvatar } from "@/shared/components/organisms/MultiSelectAvatar";
import {
  faCloudArrowDown,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  optionAvatar,
} from "@/shared/components/organisms/SelectAvatar";
import { formatDateUTC, parseDateUTC } from "@/shared/utils/formatedDate";
import { useFormik } from "formik";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { CatchmentRequest } from "@/app/catchment/catchment.types";

export const initialValues: CatchmentRequest = {
  search: "",
  branch_filter: null,
  sex_filter: null,
  campaign_filter: null,
  stages_filter: null,
  stages_users_filter: null,
  tag_marketing_filter: null,
  catchment_page: "campaigns",
};

const TrainingNutritionComponent = () => {
  const [catchmentExport] = useTrainingNutritionExportMutation();
  const { data: trainingData } = useGetTrainingNutritionQuery({});
  const [trainingNutrition, setTrainingNutrition] = useState<optionAvatar[]>(
    []
  );
  const [headersVerticalKpiTable, setHeadersVerticalKpiTable] = useState<
    string[]
  >([]);

  useEffect(() => {
    if (trainingData) {
      setTrainingNutrition(trainingData);
    }
  }, [trainingData]);

  const dataTable2 = {
    'Recuperaciones (Bajas Antiguas)': [0, 0, 0, 0, '0%'],
    'Captación (Directo al Centro)': [0, 0, 0, 0, '0%'],
    'Captación (Meta)': [0, 0, 0, 0, '0%'],
    'Captación (Desde formulario web de nuevas cuotas)': [0, 0, 0, 0, '0%'],
    'Captación (Convenios de empresas)': [0, 0, 0, 0, '0%'],
    'TOTALES': [0, 0, 0, 0, '0%'],
  };

  const dataTable = {
    'Filial 1 DemoGym': [0, 0, 0, 0, 0, 0, 17],
    'Filial 2 DemoGym': [0, 0, 0, 0, 0, 0, 0],
    'Filial 3 DemoGym': [0, 0, 0, 0, 0, 0, 14],
    'DemoGym Testing': [0, 0, 0, 0, 0, 0, 0],
    'Testeo domiciliacion': [0, 0, 0, 0, 0, 0, 0],
    Manual: [100, 80, 50, 0, 0, 0, 0],
  };

  const dataTableII = {
    'Filial 1 DemoGym': [0, 0, 0, 0, 0, 0, 17],
    'Filial 2 DemoGym': [0, 0, 0, 0, 0, 0, 0],
    'Filial 3 DemoGym': [0, 0, 0, 0, 0, 0, 14],
    'DemoGym Testing': [0, 0, 0, 0, 0, 0, 0],
    'Testeo domiciliacion': [0, 0, 0, 0, 0, 0, 0],
    Automatizado: [200, 150, 100, 0, 0, 0, 0],
  };

  const rowColors = [
    'bg-[#fc7cb4]',
    'bg-[#D7C2FF]',
    'bg-gray-300',
    'bg-gray-100',
    'bg-gray-100',
    'bg-gray-100',
    'bg-gray-100',
  ];

  useEffect(() => {
    const loadHeaders = () => {
      const headers = [
        t("user.views.plans_made"),
        t("user.views.urgent_renovations"),
        t("user.views.pendding_renovations"),
        t("user.views.week_renovations"),
        t("user.views.next_week_renovations"),
        t("user.views.does_not_need_renovations"),
        t("user.views.expired"),
      ];
      setHeadersVerticalKpiTable(headers);
    };

    loadHeaders();
  }, []);

  type FormikProps = {
    specials: number[];
    date_start: string;
    date_end: string;
  };

  const formikTrainingPrograms = useFormik<FormikProps>({
    initialValues: {
      specials: [],
      date_start: formatDateUTC(new Date()),
      date_end: formatDateUTC(new Date()),
    },
    onSubmit: async () => {},
  });

  const { data, error, isLoading } = useGetRecalculatePlanQuery(
    formikTrainingPrograms.values
  );

  useEffect(() => {
    if (data) {
      dataTable["Manual"][0] = data["totalAmount"];
      dataTable["Manual"][1] = data["totalAmount"];
      dataTable["Manual"][2] = [];
      dataTable["Manual"][3] = [];
      dataTable["Manual"][4] = [];
      dataTable["Manual"][5] = [];
      dataTable["Manual"][6] = [];

      data["userLests"][1].forEach((value: any, index: number) => {
        dataTable["Manual"][2][index] = value["countManual"];
      });

      data["userLests"][3].forEach((value: any, index: number) => {
        dataTable["Manual"][3][index] = value["countManual"];
      });

      data["userLests"][7].forEach((value: any, index: number) => {
        dataTable["Manual"][4][index] = value["countManual"];
      });

      data["userLests"][59].forEach((value: any, index: number) => {
        dataTable["Manual"][5][index] = value["countManual"];
      });

      data["userLests"][60].forEach((value: any, index: number) => {
        dataTable["Manual"][6][index] = value["countManual"];
      });
    }
    console.log(data);
    console.log(dataTable, "dataTable");
  }, [data]);

  const [formValues, setFormValues] = useState(initialValues);

  const handleExport = async () => {
    try {
      const response = await catchmentExport({
        ...formValues,
      }).unwrap();

      // Crear un blob con el tipo de contenido correcto
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "summary.xlsx"); // Nombre del archivo
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Liberar el objeto URL después de la descarga
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting catchment:", error);
    }
  };

  return (
    <>
      <div className="p-4">
        <DescriptionHeadings
          title={t("user.views.main_message23")}
          description={t("user.views.main_message24")}
        />
      </div>
      <div className="grid grid-cols-12 gap-4 p-4">
        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.main_message20")}
            </h4>
          </div>
          <div className="md:px-8 sm:px-4">
            <div className="form flex flex-col gap-4 md:flex-row">
              <div className="flex-1">
                <MultiSelectAvatar
                  options={trainingNutrition}
                  selected={trainingNutrition.filter((training) =>
                    (formikTrainingPrograms.values.specials || []).includes(training.id)
                  )}
                  setSelected={(selectedTrainings) => {
                    const selectedIds = selectedTrainings.map((training) => training.id);
                    formikTrainingPrograms.setFieldValue("specials", selectedIds);
                  }}
                  tittle={t("user.views.coach")}
                  labelClassName="md:mb-6 lg:mb-6 xl:mb-0"
                />
              </div>
              <div className="flex-1">
                <DateRangePicker
                  label={t("user.views.date_range")}
                  id="2"
                  value={{
                    startDate: parseDateUTC(formikTrainingPrograms.values.date_start),
                    endDate: parseDateUTC(formikTrainingPrograms.values.date_end),
                  }}
                  onDateChange={(startDate: Date, endDate: Date) => {
                    formikTrainingPrograms.setFieldValue(
                      "date_start",
                      formatDateUTC(startDate)
                    );
                    formikTrainingPrograms.setFieldValue(
                      "date_end",
                      formatDateUTC(endDate)
                    );
                  }}
                />
              </div>
              <div className="mt-4 md:mt-12 lg:mt-6 xl:mt-0">
                <div className="relative">
                  <button
                    type="button"
                    className="text-gray-400 hover:text-gray-500 hidden md:block mt-6"
                  >
                    <span className="sr-only">Export</span>
                    <FontAwesomeIcon
                      icon={faCloudArrowDown}
                      aria-hidden="true"
                      className="h-10 w-10"
                      onClick={handleExport}
                    />
                  </button>
                </div>
                {/*
                <ButtonPrimary
                  size="large"
                  text={t("user.views.search")}
                  onClick={formikTrainingPrograms.submitForm}
                />
                */}
              </div>
            </div>
            <div>
              <div className="flex justify-center p-4">
                <KpiTableNRCComponent
                  dataTable={dataTable}
                  dataTableII={dataTableII}
                  headersVertical={headersVerticalKpiTable}
                  rowColors={rowColors}
                  rowColorsData={rowColors}
                />
              </div>
              <div className="flex flex-wrap items-center justify-between px-5 mt-5">
                <div className="w-full md:w-1/2 mb-4 md:mb-0">
                  <div className="flex flex-col md:flex-row items-center justify-between px-5">
                    <div className="w-full md:w-1/2 mb-2 md:mb-0">
                      <div className="text-gray-500 mt-2">
                        <small>{t("user.views.main_message21")}</small>
                      </div>
                    </div>
                    <div className="w-full md:w-1/2">
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6 w-full md:w-auto"
                      >
                        12
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2">
                  <div className="flex flex-col md:flex-row items-center justify-between px-5">
                    <div className="w-full md:w-1/2 mb-2 md:mb-0">
                      <div className="text-gray-500 mt-2">
                        <small>{t("user.views.main_message22")}</small>
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6 w-full md:w-auto"
                      >
                        12
                      </button>
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6 w-full md:w-auto"
                      >
                        13%
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white shadow rounded-lg p-4 col-span-12 sm:col-span-12">
          <div className="mb-4">
            <h4 className="text-base font-semibold leading-6 text-gray-900 text-center">
              {t("user.views.main_message30")}
            </h4>
          </div>
          <div className="md:px-8 sm:px-4">
            <div className="form flex flex-col gap-4 md:flex-row">
              <div className="flex-1">
                <MultiSelectAvatar
                  options={trainingNutrition}
                  selected={trainingNutrition.filter((training) =>
                    (formikTrainingPrograms.values.specials || []).includes(training.id)
                  )}
                  setSelected={(selectedTrainings) => {
                    const selectedIds = selectedTrainings.map((training) => training.id);
                    formikTrainingPrograms.setFieldValue("specials", selectedIds);
                  }}
                  tittle={t("user.views.coach")}
                  labelClassName="md:mb-6 lg:mb-6 xl:mb-0"
                />
                {/*<SelectAvatar
                  selected={undefined}
                  options={trainingNutrition}
                  setSelected={function (option: optionAvatar): void {
                    throw new Error("Function not implemented.");
                  }}
                  tittle={t("user.views.coach")}
                />*/}
              </div>
              <div className="flex-1">
                <DateRangePicker label={t("user.views.date_range")} id="2" />
              </div>
              <div className="mt-4 md:mt-12 lg:mt-6 xl:mt-0">
                <div className="relative">
                  <button
                    type="button"
                    className="text-gray-400 hover:text-gray-500 hidden md:block mt-6"
                  >
                    <span className="sr-only">Export</span>
                    <FontAwesomeIcon
                      icon={faCloudArrowDown}
                      aria-hidden="true"
                      className="h-10 w-10"
                      onClick={handleExport}
                    />
                  </button>
                </div>
                {/*
                  <ButtonPrimary size="large" text={t("user.views.search")} />
                */}
              </div>
            </div>
            <div>
              <div className="px-4">
                <div className="flex justify-center p-4">
                  <KpiTableNRCComponent
                    dataTable={dataTable}
                    dataTableII={dataTableII}
                    headersVertical={headersVerticalKpiTable}
                    rowColors={rowColors}
                    rowColorsData={rowColors}
                  />
                </div>
              </div>
              <div className="flex flex-wrap items-center justify-between px-5 mt-5">
                <div className="w-full md:w-1/2 mb-4 md:mb-0">
                  <div className="flex flex-col md:flex-row items-center justify-between px-5">
                    <div className="w-full md:w-1/2 mb-2 md:mb-0">
                      <div className="text-gray-500 mt-2">
                        <small>{t("user.views.main_message21")}</small>
                      </div>
                    </div>
                    <div className="w-full md:w-1/2">
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6 w-full md:w-auto"
                      >
                        12
                      </button>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2">
                  <div className="flex flex-col md:flex-row items-center justify-between px-5">
                    <div className="w-full md:w-1/2 mb-2 md:mb-0">
                      <div className="text-gray-500 mt-2">
                        <small>{t("user.views.main_message22")}</small>
                      </div>
                    </div>
                    <div className="w-full md:w-1/2 flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6 w-full md:w-auto"
                      >
                        12
                      </button>
                      <button
                        id="data_31"
                        className="btn btn-default font-bold py-3 px-6 w-full md:w-auto"
                      >
                        13%
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrainingNutritionComponent;
